import Component from './container'

export default Component
export { LIMIT_PAGINATION_VALUES } from '@components_pop/Pagination/constants'
export { DEFAULT_PAGINATION_LIMIT } from '@components_pop/Pagination/constants'
